import { useState } from "react";
import { ActionMeta, InputActionMeta } from "react-select";
import Select from 'react-select'

interface Props {
    label: string;
    id: string;
    defaultValue?: string;
    value?: string;
    dataTextField: string;
    dataValueField: string;
    handleChange?: any;
    rows: any[];
    customLeftCols?: any; // for example col-sm-3
    customRightCols?: any; // for example col-sm-9
}

const ComboBoxDataEditable = (props: Props) => {

    let leftColumnClass = `${props.customLeftCols ?? "col-sm-3"
        } col-form-label zvlabel`;

    let rightColumnClass = `${props.customRightCols ?? "col-sm-9"}`;

    let options: any[] = [];

    props.rows.forEach(item => {
        options.push({ 'label': item[props.dataTextField], 'value': item[props.dataValueField] });
    });

    let selectedOption: any = undefined;

    if (options.length > 0) {
        selectedOption = options.filter(option => option.value == props.value);
    }

    return (
        <div className="row">
            {props.label && (
                <label htmlFor={props.id} className={leftColumnClass}>
                    {props.label}
                </label>
            )}

            <div className={rightColumnClass}>
                <Select
                    id={props.id}
                    options={options}
                    isClearable={false}
                    isSearchable={true}
                    value={selectedOption}
                    onChange={(newValueObject)=>{
                        props.handleChange(newValueObject.value);
                    }}
                    
                    placeholder=''
                />
            </div>
        </div>
    );
};

export default ComboBoxDataEditable;
